/**
 * A module that sets up dependencies required by the AB testing framework.
 * @module abt-core/dependencies
 */

import _ from 'lodash'
import cookies from '../abt-utils/cookies'
import siteConfig from './site-config.json'
import { log } from '../abt-utils/logger'

/** Initialize AB testing dependencies. */
export function init () {
  _createBucketCookie()
  _createMonetateCookie()
  _loadMonetateScript()
}

/**
 * Creates the test bucket cookie.
 *
 * This cookie will contain a string value between 1-20 and will be used to determine if the
 * user should be included in an AB test. It is required and must be created before running
 * any AB tests and loading the Monetate script. Monetate depends on this cookie for bucket
 * targeting.
 */
function _createBucketCookie () {
  var value = _.random(siteConfig.buckets).toString()
  _createCookie(siteConfig.cookies.bucketCookieName, value)
}

/**
 * Creates the Monetate cookie.
 *
 * This cookie will contain the value `true` once it has been created. It is required and must
 * be created before loading the Monetate script. Monetate depends on this cookie for who
 * targeting.
 */
function _createMonetateCookie () {
  _createCookie(siteConfig.cookies.monetateCookieName, 'true')
}

/** Adds the Monetate script to the page asynchronously. */
function _loadMonetateScript () {
  var monetateT = new Date().getTime()

  ;(function () {
    var p = document.location.protocol

    if (p === 'http:' || p === 'https:') {
      var m = document.createElement('script')
      m.type = 'text/javascript'
      m.async = true
      m.src = (p === 'https:' ? 'https://s' : 'http://') +
        'b.monetate.net/js/1/a-09ac03c2/p/bestbuy.com/' +
        Math.floor((monetateT + 268098) / 3600000) + '/g'

      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(m, s)
    }
  })()

  log('ABT: loaded monetate script')
}

/**
 * Creates a cookie.
 * If the cookie already exists, the method does nothing and returns early.
 * @param {string} cookieName - The name of the cookie.
 * @param {string} value - The value to assign to the cookie.
 */
function _createCookie (cookieName, value) {
  if (!cookies.get(cookieName)) {
    cookies.set(cookieName, value, new Date(siteConfig.cookies.expiration))
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/dependencies.js
 ** module id = 44
 ** module chunks = 2
 **/